import React, { useEffect, useState } from "react";
import axios from "axios";

const apiRequestAddress =
  process.env.REACT_APP_API_ENDPOINT || window.location.origin + "/json.rpc";

const SuperSession = () => {
  const [transformersList, setTransformersList] = useState(null);
  const [error, setError] = useState(null);

  const onChooseOrganizationHandler = (orgId) => {
    console.log(orgId);
    axios
      .post(
        apiRequestAddress,
        {
          method: "Auth.ChangeOrganization",
          params: [`${orgId}`],
          id: 156,
        },
        {
          withCredentials: true,
        }
      )
      .then((res) => {
        if (res.data.result && res.data.result === "ok") {
          window.location.reload();
        } else {
          setError(res.data.error);
        }
      });
  };

  useEffect(() => {
    axios
      .post(
        apiRequestAddress,
        {
          jsonrpc: "2.0",
          method: "Data.GetEntityData",
          params: {
            entity: "EU_TransformerCustomers",
            format: "Full",
          },
          id: 30,
        },
        {
          withCredentials: true,
        }
      )
      .then((res) => {
        if (res.data && res.data.result) {
          setTransformersList(res.data.result.data);
        }
      });
  }, []);

  return (
    <div>
      <p>
        No organization detected. Please choose an organization you want to log
        into:
      </p>
      {transformersList && (
        <select
          name="transformers"
          id="transformers-list"
          onChange={(event) => onChooseOrganizationHandler(event.target.value)}
        >
          {transformersList.map((org) => (
            <option
              value={org.CustomerId}
              key={org.CustomerId}
              //   onChange={() => onChooseOrganizationHandler(org.CustomerId)}
            >
              {org.CustomerId__OrganisationShortName}
            </option>
          ))}
        </select>
      )}
      {error && (
        <p
          style={{ color: "red" }}
        >{`The following error occured: Code ${error.code}, Message: ${error.message}`}</p>
      )}
    </div>
  );
};

export default SuperSession;
